import styled, { css } from 'styled-components'
import icon from '../../assets/Icons/search-icon.svg'

export const Container = styled.div`
  ${({ margin }) => css`
    input {
      background: 16px center url(${icon}) no-repeat;
      border-radius: var(--border-radius-lg);
      border: 1px solid var(--text-light);
      width: 390px;
      height: 48px;
      padding: 18px 16px 18px 40px;
      margin: ${margin || 'unset'};

      color: var(--text-tertiary);
      font-size: var(--font-size-md);
      font-weight: 400;

      ::placeholder {
        color: var(--bs-gray-500);
        font-size: var(--font-size-sm);
      }

      @media (max-width: 992px) {
        width: 100%;
      }
    }
  `}
`
